import React, {useEffect, useState} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Divider,
    Grid,
    Button,
    TextField
} from '@material-ui/core';
import validate from 'validate.js';
import {updateProfile} from '../../../../apis/api';
import formSchema from '../../../../common/formSchema';

const useStyles = makeStyles(() => ({
    root: {}
}));

const AccountDetails = props => {
    const {className, user, ...rest} = props;
    // email,
    //     name,
    //     position,
    //     dept,
    //     fax_number, re
    //     phone_number, re
    //     company_name,
    //     company_owner_name,
    //     company_business_number, re
    //     company_address
    const MESSAGE = {
        SUCCESS: '프로필 변경이 완료되었습니다.',
        FAIL: '네트워크 문제가 발생하였습니다. 다시 시도해 주시기 바랍니다.'
    };
    const classes = useStyles();

    const [formState, setFormState] = useState({
        isValid: false,
        values: {
            ...user,
            fax_number: user.fax_number && user.fax_number.replace(/-/gi, ''),
            phone_number: user.phone_number && user.phone_number.replace(/-/gi, ''),
            company_business_number: user.company_business_number && user.company_business_number.replace(/-/gi, ''),
        } || {},
        touched: {},
        errors: {}
    });

    useEffect(() => {
        const errors = validate(formState.values, formSchema);

        setFormState(formState => ({
            ...formState,
            isValid: !errors,
            errors: errors || {}
        }));
    }, [formState.values]);

    const handleChange = event => {
        event.persist();

        setFormState(formState => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]:
                    event.target.type === 'checkbox'
                        ? event.target.checked
                        : event.target.value
            },
            touched: {
                ...formState.touched,
                [event.target.name]: event.target.value !== ''
            }
        }));
    };

    const errorHandler = () => {
        alert(MESSAGE.FAIL);
    };

    const handleUpdate = event => {
        event.preventDefault();

        updateProfile(formState.values)
            .then(res => {
                if (res.isMemberChanged) {
                    alert(MESSAGE.SUCCESS);
                    return;
                }
                alert(MESSAGE.FAIL);
            }).catch(() => {
                errorHandler();
            });
    };

    const hasError = field => !!(formState.touched[field] && formState.errors[field]);

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <form
                autoComplete="off"
                noValidate
                onSubmit={handleUpdate}
            >
                <CardHeader
                    subheader="The information can be edited"
                    title="Profile"
                />
                <Divider/>
                <CardContent>
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                className={classes.textField}
                                fullWidth
                                error={hasError('company_name')}
                                helperText={
                                    hasError('company_name') ? formState.errors.company_name[0] : null
                                }
                                label="회사명"
                                margin="dense"
                                name="company_name"
                                onChange={handleChange}
                                type="text"
                                value={formState.values.company_name || ''}
                                variant="outlined"
                                InputLabelProps={{style: {color: 'gray'}}}
                            />
                            <TextField
                                className={classes.textField}
                                error={hasError('company_business_number')}
                                fullWidth
                                helperText={
                                    hasError('company_business_number') ? formState.errors.company_business_number[0] : null
                                }
                                label="사업자등록번호"
                                margin="dense"
                                name="company_business_number"
                                onChange={handleChange}
                                type="number"
                                value={formState.values.company_business_number || '123'}
                                variant="outlined"
                                placeholder="숫자만 입력하세요."
                                InputLabelProps={{style: {color: 'gray'}}}
                            />
                            <TextField
                                className={classes.textField}
                                error={hasError('company_owner_name')}
                                fullWidth
                                helperText={
                                    hasError('company_owner_name') ? formState.errors.company_owner_name[0] : null
                                }
                                label="대표자명"
                                margin="dense"
                                name="company_owner_name"
                                onChange={handleChange}
                                type="text"
                                value={formState.values.company_owner_name || ''}
                                variant="outlined"
                                InputLabelProps={{style: {color: 'gray'}}}
                            />
                            <TextField
                                className={classes.textField}
                                error={hasError('company_address')}
                                fullWidth
                                helperText={
                                    hasError('company_address') ? formState.errors.company_address[0] : null
                                }
                                label="회사주소"
                                margin="dense"
                                name="company_address"
                                onChange={handleChange}
                                type="text"
                                value={formState.values.company_address || ''}
                                variant="outlined"
                                InputLabelProps={{style: {color: 'gray'}}}
                            />
                            <TextField
                                className={classes.textField}
                                error={hasError('name')}
                                fullWidth
                                helperText={
                                    hasError('name') ? formState.errors.name[0] : null
                                }
                                label="담당자성명"
                                margin="dense"
                                name="name"
                                onChange={handleChange}
                                type="text"
                                value={formState.values.name || ''}
                                variant="outlined"
                                InputLabelProps={{style: {color: 'gray'}}}
                            />
                            <TextField
                                className={classes.textField}
                                error={hasError('position')}
                                fullWidth
                                helperText={
                                    hasError('position') ? formState.errors.position[0] : null
                                }
                                label="직급"
                                margin="dense"
                                name="position"
                                onChange={handleChange}
                                type="text"
                                value={formState.values.position || ''}
                                variant="outlined"
                                InputLabelProps={{style: {color: 'gray'}}}
                            />
                            <TextField
                                className={classes.textField}
                                error={hasError('dept')}
                                fullWidth
                                helperText={
                                    hasError('dept') ? formState.errors.dept[0] : null
                                }
                                label="부서"
                                margin="dense"
                                name="dept"
                                onChange={handleChange}
                                type="text"
                                value={formState.values.dept || ''}
                                variant="outlined"
                                InputLabelProps={{style: {color: 'gray'}}}
                            />
                            <TextField
                                className={classes.textField}
                                error={hasError('email')}
                                fullWidth
                                helperText={
                                    hasError('email') ? formState.errors.email[0] : null
                                }
                                label="담당자 이메일"
                                margin="dense"
                                name="email"
                                onChange={handleChange}
                                type="text"
                                value={formState.values.email || ''}
                                variant="outlined"
                                InputLabelProps={{style: {color: 'gray'}}}
                            />
                            <TextField
                                className={classes.textField}
                                error={hasError('phone_number')}
                                fullWidth
                                helperText={
                                    hasError('phone_number') ? formState.errors.phone_number[0] : null
                                }
                                label="담당자 전화번호"
                                margin="dense"
                                name="phone_number"
                                onChange={handleChange}
                                type="number"
                                value={formState.values.phone_number || ''}
                                variant="outlined"
                                placeholder="숫자만 입력하세요."
                                InputLabelProps={{style: {color: 'gray'}}}
                            />
                            <TextField
                                className={classes.textField}
                                error={hasError('fax_number')}
                                fullWidth
                                helperText={
                                    hasError('fax_number') ? formState.errors.fax_number[0] : null
                                }
                                label="팩스번호"
                                margin="dense"
                                name="fax_number"
                                onChange={handleChange}
                                type="number"
                                value={formState.values.fax_number || ''}
                                variant="outlined"
                                placeholder="숫자만 입력하세요."
                                InputLabelProps={{style: {color: 'gray'}}}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
                <Divider/>
                <CardActions>
                    <Button
                        color="primary"
                        variant="outlined"
                        type="submit"
                    >
                        Update
                    </Button>
                </CardActions>
            </form>
        </Card>
    );
};

AccountDetails.propTypes = {
    className: PropTypes.string,
    user: PropTypes.object
};

export default AccountDetails;
